import React from 'react'
import { ReportCardItemDiv, ItemText } from '../index.style'
import { Row, Col, Space } from 'antd'

const ReportCardItem = ({ title, subtitle, img }) => {
  return (
    <ReportCardItemDiv>
      <Row>
        <Col span={6}>
          <Row justify="center">
            <img src={img} alt="" width={60} height={60} />
          </Row>
        </Col>
        <Col span={18}>
          <Space direction="vertical">
            <ItemText>{title}</ItemText>
            <ItemText bold>{subtitle}</ItemText>
          </Space>
        </Col>
      </Row>
    </ReportCardItemDiv>
  )
}

export default ReportCardItem



// WEBPACK FOOTER //
// ./src/pages/Reports/ReportCardItem/index.js